<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import { Alert, Button, Col, Form, FormGroup, Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "sveltestrap";
	import type { RolState } from "../global";
	import type { Rol } from "../Model/Rol";
    import type { User } from "../Model/User";
	import { usersService } from "../services";
    import CroquisData from "./Diligence/Traffic/Data/CroquisData.svelte";
    import PhotoUnique from "./PhotoUnique.svelte";
    import SignCanvas from "./SignCanvas.svelte";
    import ParamSelect from "./ParamSelect.svelte";

	const dispatch = createEventDispatcher();

	let size = 'lg';
	let open = false;
	let roles: Rol[];

	let pass1 = '';
	let pass2 = '';
	let checkPass = true;
	let typeUser: RolState;
	let is_agent;

	export let user: User = null;

	$: load(user);

	$: open = !!user;

	function load(user){
		if (user) {
			downRoles()
			if(is_agent == undefined) {
				is_agent = user.is_agent.toString();
			}
		}
	}

	function checkPassWord(){
		if (pass1 == pass2 && pass1.length > 0) {
			return true
		}
		return false;
	}

	const toggle = () => {
	  size = 'lg';
	  open = !open;
	};
	
	async function downRoles(){
		roles = await usersService.findTypes();

		if (!user.type) {
			typeUser = roles.find(r => r.id == 2);
			user.type = typeUser;
		}else{
			typeUser = user.type
		}
	}

	async function save(){

		if(is_agent == 'true') {
			user.is_agent = true;
		} else {
			user.is_agent = false;
			user.position_id = null;
			user.agent_id = null;
			user.municipality_id = null;
		}

		const response = await saveUser();

		if(response){
			open = false;
			dispatch("userUpdate", user);
		}
	}

	async function saveUser(){

		if (checkPass && pass1.length > 5) {
			user.password = pass1
		}

		return await usersService.saveUser(user);
	}

	async function changeTypeUser(){
		user.type = typeUser;
	}

	function reloadPhoto(photoId){
        user.photo = photoId;
        saveUser();  
    }

    function removePhoto(){
        user.photo = null; 
        saveUser();  
    }

	async function addSigntToActivity(png){
    	user.sign = png
		saveUser();  
  	}

	async function eraseSign(){
    	user.sign = null
		saveUser();  
  	}

  </script>

  <style>
		.form-check-footer{    
			position: absolute;
    		left: 10px;
		}
  </style>

  
	<Modal isOpen={open} {toggle} {size}>
	  	<ModalHeader {toggle}>Editar usuario</ModalHeader>
	  	<ModalBody>
			<TabContent>
				<TabPane tabId='General' tab='General' active>
					<Row class='mt-3'>
						<Col xs="8">		
							<FormGroup>
								<Label for="exampleEmail">Email</Label>
								<Input
								  type="text"
								  bind:value={user.email}
								/>
							</FormGroup>
							<FormGroup>
								<Label for="exampleSelect">Seleccione un Rol</Label>
									{#if roles && typeUser.id}
										<select class="form-select" bind:value={typeUser.id} on:change={changeTypeUser} disabled={roles.length == 1}>
											{#each roles as rol}
												<option value={rol.id}>{rol.name}</option>
											{/each}	
										</select>
									{/if}
							  </FormGroup>
							<FormGroup>
								<Label for="exampleEmail">Contraseña</Label>
								<Input
								  type="password"
								  bind:value={pass1}
								  on:keyup={() => {
										if (pass1 != pass2) {
											checkPass = false;
										}else{
											checkPass = true;
										}
									}}
								/>
							</FormGroup>
							<FormGroup>
								<Label for="exampleEmail">Repetir contraseña.</Label>
								<Input
									type="password"
									bind:value={pass2}
									on:keyup={() => {
										if (pass1 != pass2) {
											checkPass = false;
										}else{
											checkPass = true;
										}
									}}
								/>
							</FormGroup>
							{#if !checkPass}
								<Alert color="warning">¡Atención!: Las contraseñas no coinciden</Alert>
							{/if}
						</Col>
						<Col>
							<FormGroup>
								<Label for="exampleEmail">Imagen</Label>
								<PhotoUnique contextId={user.id} bind:photoId={user.photo} on:removePhoto={(event) => removePhoto()} on:updatePhoto={(event) => reloadPhoto(event.detail)}/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col xs="8"> 
							<FormGroup>
								<Label for="exampleEmail">Firma</Label>
								<Row>
									{#if user.sign}
										<img src={user.sign} alt="">
										<div class="w-full flex mt-2">
											<Button color="warning" on:click={eraseSign}>
												<Icon name="eraser-fill" /> <span class="ml-2">Borrar Firma</span>  
											</Button>
										</div>
										
									{:else}
										<SignCanvas on:savePngSign={(event) => addSigntToActivity(event.detail)} />
									{/if}
								</Row>
						
							</FormGroup>
					
						</Col>
					</Row>
				</TabPane>
				<TabPane tabId='Datos' tab='Información del usuario'>
					<Row class='mt-3'>
						<Col xs="4">
							<FormGroup>
								<Label for="exampleEmail">Nombre</Label>
								<Input
								  type="text"
								  bind:value={user.name}
								/>
							</FormGroup>	
						</Col>
						<Col xs="4">
							<FormGroup>
								<Label for="exampleEmail">Primer apellido</Label>
								<Input
								  type="text"
								  bind:value={user.surname1}
								/>
							</FormGroup>	
						</Col>
						<Col xs="4">
							<FormGroup>
								<Label for="exampleEmail">Segundo apellido</Label>
								<Input
								  type="text"
								  bind:value={user.surname2}
								/>
							</FormGroup>	
						</Col>
						<Col xs="6">
							<FormGroup>
								<Label for="exampleEmail">DNI</Label>
								<Input
								  type="text"
								  bind:value={user.dni}
								/>
							</FormGroup>
						</Col>
						<Col xs="6">
							<FormGroup>
								<Label for="exampleEmail">Teléfono</Label>
								<Input
								  type="text"
								  bind:value={user.phone}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row cols={2}>	
						<Col>
							<FormGroup>
								<Label for="is_agent">Es agente</Label>
								<Input type="select" bind:value={is_agent} on:change={() => is_agent == 'true' ? user.is_agent = true : user.is_agent = false}>
									<option value='true'>Si</option>
									<option value='false'>No</option>
								</Input>
							  </FormGroup>
						</Col>
						{#if is_agent == 'true'}
							<Col>
								<Label for="is_agent">Código del agente</Label>
								<ParamSelect bind:paramSelectId={user.agent_id} paramType='agentList' nothing={false}/>
							</Col>
						{/if}
					</Row>
					{#if is_agent == 'true'}
					<Row>
						<Col xs='6'>
							<Label for="is_agent">Municipio del agente</Label>
							<ParamSelect bind:paramSelectId={user.municipality_id} paramType='municipality' nothing={false}/>
						</Col>
						<Col xs='6'>
							<Label for="is_agent">Cargo</Label>
							<ParamSelect bind:paramSelectId={user.position_id} paramType='agentPosition' nothing={false}/>
						</Col>
					</Row>
					{/if}
				</TabPane>
			</TabContent>


	  </ModalBody>
	  <ModalFooter>
		  <div class="form-check-footer">
			<FormGroup>
				<Input type="checkbox" label="Activado"  bind:checked={user.enabled}/>
			</FormGroup>
		  </div>
		<Button color="primary" on:click={save} disabled={!checkPass}>Guardar</Button>
	  </ModalFooter>
	</Modal>